/**
 * 행 확대 축소
 */
export const CHANGE = 'analysis/rows/expandRow/CHANGE' // 값 변경시
export const INIT = 'analysis/rows/expandRow/INIT'     // 초기 쿠키에서 값 가져올때

type Type = {
    expand: boolean;
}

// order: answer => 보기순, count => 응답순
// pointType: point => 가중치로 계산, count => 응답수로 계산 
const initState: Type = {
    expand: false
}
  
interface ActionProps {
    type: string;
    expand: Type['expand'];
}

export default (state = initState, action: ActionProps) => {
    switch(action.type) {
        case CHANGE:
            return {
                expand: action.expand
            }
        case INIT:
            return initState
        default:
            return state
    }
}